import React from 'react';
import { Table, Tag } from 'antd';
import '../../../style/table.less';
const { Summary } = Table;

const tagColor = '#9254de';

const FeedbackDetailTableStatistic = (props) => {
  const { feedbackStatistic } = props;
  return (
    <>
      <Summary.Row>
        <Summary.Cell>上课总人数</Summary.Cell>
        <Summary.Cell colSpan={1}>
          <Tag color={tagColor}>{feedbackStatistic}</Tag>
        </Summary.Cell>
      </Summary.Row>
    </>
  );
};

export default FeedbackDetailTableStatistic;
